import { render, staticRenderFns } from "./NewContentCard.vue?vue&type=template&id=a41bfc56&"
import script from "./NewContentCard.vue?vue&type=script&lang=js&"
export * from "./NewContentCard.vue?vue&type=script&lang=js&"
import style0 from "./NewContentCard.vue?vue&type=style&index=0&id=a41bfc56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports